import styled from 'styled-components';
import { BREAKPOINT } from '@latitude/core/utils/constants';
import { Link } from '@latitude/link';
export const StyledAppLinks = /*#__PURE__*/styled.div.withConfig({
  displayName: "AppLinksstyles__StyledAppLinks",
  componentId: "sc-vk1hi2-0"
})(["display:flex;flex-direction:column;@media (min-width:", "){flex-direction:row;align-items:center;justify-content:center;}"], BREAKPOINT.LG);
export const AppLinksContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "AppLinksstyles__AppLinksContainer",
  componentId: "sc-vk1hi2-1"
})(["display:flex;"]);
export const AppLink = /*#__PURE__*/styled(Link).withConfig({
  displayName: "AppLinksstyles__AppLink",
  componentId: "sc-vk1hi2-2"
})(["margin:8px 16px 0 0;img{display:block;width:119px;}@media (min-width:", "){margin:0 0 0 24px;img{width:128px;}}"], BREAKPOINT.LG);